export default "__VITE_ASSET__$L2egb8b__"